import React, { useState } from 'react'
import DndList from './DndList'
import { Box } from '@mui/material'
import { H3 } from '../../../../layouts/TextStyles'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import AddHomeworkDialog from './Dialogs/AddHomeworkDialog'
import { useParams } from 'react-router-dom'
import { homeworkApiSlice } from '../../../../features/section/homeworkSlice'

interface Props {
    homework: any[]
    refetchHomework?: () => void
}

const TopicHomeworkList = ({ homework, refetchHomework = () => { } }: Props) => {
    const { formatMessage } = useIntl()
    const { courseTopicId } = useParams()
    const [deleteHomework] = homeworkApiSlice.useDeleteHomeworkMutation()
    const [editHomeworkItem, setEditHomeworkItem] = useState<any>(null)
    const handleEditHomework = (element: any) => {
        setEditHomeworkItem(element)
    }

    const handleDeleteHomework = async (item: any) => {
        try {
            await toast.promise(deleteHomework(item.id).unwrap(), {
                pending: formatMessage({ id: 'deleting' }),
                success: formatMessage({ id: 'deletedSuccess' }),
                error: formatMessage({ id: 'deletedError' })
            })
            refetchHomework()
        } catch (error) {
            console.error('Error deleting homework:', error)
        }
    }

    // Преобразуем homework данные в формат, ожидаемый DndList
    const homeworkItems = homework.map(item => ({
        ...item, // Сохраняем все оригинальные поля homework
        type: 'homework', // Добавляем тип для корректного отображения
        isReady: true // Homework всегда доступен
    }))

    return (
        <Box>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', my: 4 }}>
                <H3>
                    {formatMessage({ id: 'homework' })}
                </H3>

                <AddHomeworkDialog
                    courseTopicId={Number(courseTopicId)}
                    editHomework={editHomeworkItem}
                    setEditHomework={setEditHomeworkItem}
                    refetchHomework={refetchHomework}
                />
            </Box>
            {homeworkItems && (
                <DndList
                    items={homeworkItems}
                    editDnd={false}
                    setEditRow={handleEditHomework}
                    onDelete={handleDeleteHomework}
                />
            )}
        </Box>
    )
}

export default TopicHomeworkList